// extracted by mini-css-extract-plugin
export default {"Rating":"hoVcwfvKKek5Kw4QNNSa","Rating_explanation":"DhYuptgfBkT16ZQd4C0L"};